import React from 'react';
import styled from 'styled-components';

import COLORS from 'constants/colors';
import ToolTipBody from 'shared/ToolTip/components/ToolTipBody';
import IPhysicalAnalysisFailure from 'types/model/IPhysicalAnalysisFailure';
import { failureExplanation } from 'utils/physicalAnalysis/failureExplanation';

// PLA-1077 v2: (i) junto a la etiqueta de un campo en rojo del cierre del asistente. Al
// pulsarlo explica por que el valor no cumple el parametro del origen.
const Wrapper = styled.span`
  margin-left: 0.35em;
  vertical-align: middle;
  font-weight: normal;

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li + li {
    margin-top: 0.25em;
  }
`;

interface Props {
  detail: IPhysicalAnalysisFailure;
}

const FailureInfoTooltip = ({ detail }: Props) => {
  const { title, lines } = failureExplanation(detail);

  const component = (): JSX.Element => (
    <>
      <span>{title}</span>
      <ul>
        {lines.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
    </>
  );

  return (
    <Wrapper data-cy={`failure-info-${detail.field}`}>
      <ToolTipBody component={component} iconColor={COLORS.RED} top />
    </Wrapper>
  );
};

export default FailureInfoTooltip;
